import React from 'react';
import Span from '../../atoms/spans/Span';
import Paragraph from '../../atoms/paragraphs/Paragraph';

const InfoDisplayCard = ({
  title,
  amount,
  description,
  colorClass = 'color-gray-400',
  link,
}) => {
  return (
    <div className='d-flex flex-column flex-grow-1 info-card-display px-4 py-3'>
      {(title && (
        <Paragraph className='title text-header h4 mb-2'>{title}</Paragraph>
      )) || <></>}
      {((amount || description || link) && (
        <div className='d-flex flex-wrap mt-auto'>
          {(amount && (
            <Span
              className={`amount ${colorClass} font-bold lh-1 fs-4 mt-auto`}
            >
              {amount}
            </Span>
          )) || <></>}

          {(description && (
            <Span className='description font-light mt-auto ms-2 mb-0 color-gray-400'>
              {description}
            </Span>
          )) || <></>}

          {(link && (
            <Span
              className='link font-light mt-auto ms-auto color-brand-primary'
              onClick={link.onClick}
            >
              {link.text}
            </Span>
          )) || <></>}
        </div>
      )) || <></>}
    </div>
  );
};

export default InfoDisplayCard;
